import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import DialogForm from "../../../shared/components/DialogForm";
import { useTranslation } from "react-i18next";

export const ChangeReservationStatus = (propsDia) => {
  const { t } = useTranslation();

  let {
    openChangeBookingStatus,
    handleChangeBookingStatus,
    bookingStatusValue,
    setBookingStatusValue,
    handleConfirmBookingStatus,
  } = propsDia;

  return (
    <DialogForm
      scroll="paper"
      // maxWidth="lg"
      maxWidth="md"
      title={t("Change Booking Status")}
      openDialog={openChangeBookingStatus}
      handleDialogClose={handleChangeBookingStatus}
      bodyContent={
        <div className="p-2">
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item lg={12} sm={12} md={12} xs={12}>
              <FormControl fullWidth>
                <Typography
                  id="font-600"
                  style={{
                    marginBottom: "11px",
                    color: "rgb(30, 30, 30)",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "500 !important",
                  }}
                >
                  {t("Booking Status")}
                </Typography>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={bookingStatusValue}
                  //label="Room Status"
                  onChange={(e) => setBookingStatusValue(e.target.value)}
                >
                  <MenuItem value={0}>{t("Select Booking Status")}</MenuItem>

                  <MenuItem value={2}> {t("Confirmed")} </MenuItem>
                  <MenuItem value={6}> {t("No Show")} </MenuItem>
                  {/* <MenuItem value={5} > {t('Cancel')} </MenuItem> */}
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12}>
              <Button
                className="mt-1 comman-button"
                size="large"
                variant="contained"
                onClick={handleConfirmBookingStatus}
                disableElevation
                color="primary"
                // style={{
                //   justifyContent: "center",
                //   width: "98px",
                //   height: "44px",
                //   textTransform: "capitalize",
                //   background:
                //     "linear-gradient(180deg, #255480 0%, #173450 100%)",
                // }}
              >
                {t("Submit")}
              </Button>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
};
